import Swiper, { Pagination } from 'swiper'

const narrowSliderContainerEls = document.querySelectorAll('.swiper-tabs')
narrowSliderContainerEls.forEach((sliderContainer) => {
    const narrowSwiperEl = sliderContainer.querySelector('.swiper-tabs__swiper-el')
    const narrowSwiperPaginationEl = sliderContainer.querySelector('.swiper-tabs__pagination')
    const tabCategories = narrowSwiperPaginationEl.getAttribute('data-tab-categories')?.split('^') ?? []
    const fullWidth = !!narrowSwiperPaginationEl.getAttribute('data-variant')

    new Swiper(narrowSwiperEl, {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: fullWidth ? 40 : 0,
        pagination: {
            el: narrowSwiperPaginationEl,
            clickable: true,
            renderBullet: function (index, className) {
                return fullWidth
                    ? `<div class="h4 col-6 offset-0 col-lg-2  offset-lg-` +
                          `${index * 2}  ` +
                          className +
                          '">' +
                          `${tabCategories[index]}` +
                          '</div>'
                    : `<div class="h4 col-7 offset-1 col-lg-2  offset-lg-` +
                          `${2 + index * 2}  ` +
                          className +
                          '">' +
                          `${tabCategories[index]}` +
                          '</div>'
            }
        }
    })
})
